// extracted by mini-css-extract-plugin
export default {"list":"List_list__CclgG","listItem":"List_listItem__6RXvr"};